import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=1c833626&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=1c833626&lang=scss&scoped=true&"
import style1 from "./VideoCard.vue?vue&type=style&index=1&id=1c833626&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c833626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c833626')) {
      api.createRecord('1c833626', component.options)
    } else {
      api.reload('1c833626', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=1c833626&scoped=true&", function () {
      api.rerender('1c833626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/VideoCard/VideoCard.vue"
export default component.exports